export default {
  operatedBy: 'Operated By: {{unit}}',
  btnBook: 'Reserve',
  shuttleFull: 'This trip is fully booked',
  freeSeats: {
    seat: '{{seats}} seat left',
    seats: '{{seats}} seats left', 
  }
};